<template>
    <div>
        <div class="main">
            <div class="title">
                中奖记录
                <div @click="back" class="back">
                    <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
                </div>
            </div>
            <div class="roll_list" :style="'width: 100%;padding: 0 4%;box-sizing: border-box;'+'height:'+height+'px'+';overflow-y:auto;'">
               <div class="cion_item" v-for="(item , index) in dataList" :key="index">
                   <div class="left_flex">
                       <div class="fn_cionexple">{{item.awardName}}</div>
                       <div class="fn_ciontime">中奖时间：{{formatDateDetail(item.createTime)}}</div>
                   </div>
                   <div class="right_flex">
                       <div @click="$router.push('/cardroll')" class="cion_integral">
                           立即查看
                       </div>
                   </div>
               </div>
            </div>
        </div>

    </div>
</template>
<script>

import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '../../../appConfig';

// util
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';

const config = {
    apiConfig : {
        list : {
            url : '/portal/lotto/champion',
             params:{
            },
            // totalPagePath : 'data.pages',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',

        }
    }
};

export default {
    name:'awardDetail',
    extends:shixunPagePart,


    data(){
        return{
            height:0,

             scrollControl:{
                viewContainer:'.roll_list',
                scrollContainer:".roll_list"
            },
            enableDataList : true,
            autoLoadDataList : true,
            // scrollToLoadNextPage:true,
            apiConfig : config.apiConfig,
            title:'中奖记录',
            pageSize : 20,

            detailId:'',



        }
    },
    created(){
        let h = document.documentElement.clientHeight || document.body.clientHeight
        this.height = h - 64;

         this.detailId =  this.$route.params.id;
        this.apiConfig.list.params.id = this.detailId

    },
    methods:{
        back(){
             appHelper.back(this)
        },

        formatDateDetail(timer){
            let time = new Date(timer)
            let Y = time.getFullYear();
            let M = time.getMonth() + 1;
                M = M < 10 ? '0' + M : M;// 不够两位补充0
            let D = time.getDate();
                D = D < 10 ? '0' + D : D;
            let H = time.getHours();
                H = H < 10 ? '0' + H : H;
            let Mi = time.getMinutes();
                Mi = Mi < 10 ? '0' + Mi : Mi;
            let S = time.getSeconds();
                S = S < 10 ? '0' + S : S;
                return Y + '-' + M + '-' + D + ' ' + H + ':' + Mi + ':' + S;
        },

        setWechatShare : function()
        {

            let wechatShareOptions = {
                title   : appHelper.getTitle(),
                desc    : this.desc,
                link    : location.href,
                imgUrl  : appHelper.getAppIcon() // 分享图标
            };
            wechatHelper.setShare(wechatShareOptions);
        },
    },

    mounted(){

        appHelper.setTitle(this.title);

        if (deviceHelper.isBrowser && browserHelper.isWechat)
        {
            this.setWechatShare();
        }

    }
}
</script>
<style lang="scss" scoped>
.main{

    width: 100%;
    box-sizing: border-box;
    background: #fff;
}

.title{
    width: 100%;
    height: 44px;
    text-align: center;
    line-height: 44px;
    font-size: 20px;

    font-weight: 600;
    color: #333333;

    overflow: hidden;
    margin-bottom: 10px;

}
.back{
    float: left;
    margin-top: 4px;
}

.cion_item{
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    .fn_cionexple{

        font-size: 14px;

        font-weight: 600;
        color: #333333;

    }
    .fn_ciontime{

        font-size: 12px;

        font-weight: 600;
        color: #999999;

    }

    .right_flex{
        height: 37px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }


    .cion_integral{
        width: 63px;
        height: 22px;
        text-align: center;
        font-size: 12px;

        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;
        background: #FF4D51;

        border-radius: 12px;
    }



}



</style>
